module.exports = __webpack_public_path__ + "img/unionpay.dda7c4a7.jpeg";